import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck } from 'lucide-react';
import { Button } from './Button';
export function Pricing() {
  return <section id="precio" className="py-20 bg-[#fafaf9]" data-id="element-109">
      <div className="container mx-auto px-4 md:px-6" data-id="element-110">
        <div className="max-w-lg mx-auto" data-id="element-111">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-stone-100" data-id="element-112">
            <div className="bg-[#10b981] p-6 text-center text-white" data-id="element-113">
              <h2 className="text-2xl font-bold mb-2" data-id="element-114">
                Plantilla de Finanzas Personales
              </h2>
              <p className="opacity-90" data-id="element-115">Oferta por tiempo limitado</p>
            </div>

            <div className="p-8 md:p-10" data-id="element-116">
              <div className="flex flex-col items-center mb-8" data-id="element-117">
                <span className="text-stone-400 line-through text-xl mb-1" data-id="element-118">
                  $49.990
                </span>
                <div className="flex items-baseline gap-1" data-id="element-119">
                  <span className="text-5xl font-bold text-stone-900" data-id="element-120">
                    $19.990
                  </span>
                  <span className="text-stone-500 font-medium" data-id="element-121">ARS</span>
                </div>
                <span className="inline-block mt-4 px-3 py-1 bg-green-100 text-green-700 text-xs font-bold rounded-full uppercase tracking-wide" data-id="element-122">
                  Pago Único • Acceso Inmediato
                </span>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-123">
                {['Plantilla Editable en Google Sheets', 'Gestión de Ingresos y Gastos', 'Control de Ahorros y Deudas', 'BONUS: Planificador Imprimible', 'BONUS: Video Tutorial Paso a Paso', 'Actualizaciones futuras incluidas'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-124">
                    <Check className="w-5 h-5 text-[#10b981] flex-shrink-0 mt-0.5" data-id="element-125" />
                    <span className="text-stone-700" data-id="element-126">{item}</span>
                  </li>)}
              </ul>

              <Button href="https://checkout.tuvidasimple.shop/products/plantilla-de-finanzas-personales?variant=44058955939942" fullWidth className="mb-4" data-id="element-127">
                Acceder ahora por $19.990
              </Button>

              <div className="flex items-center justify-center gap-2 text-xs text-stone-400" data-id="element-128">
                <ShieldCheck className="w-4 h-4" data-id="element-129" />
                <span data-id="element-130">Compra segura y garantizada</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}